<template>
  <div>
    <el-form :model="form">
      <el-input v-model="form.authorizeCause" type="textarea" maxlength="255" show-word-limit :rows="2" placeholder="请输入内容" />
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="rejxiao()">取 消</el-button>
      <el-button type="primary" @click="rejque(message)">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { rejectOrderDetail } from "@/api/transport";
export default {
  props: ["message"],
  data() {
    return {
      form: {
        authorizeCause: "",
        code: ""
      }
    };
  },
  created() {},
  methods: {
    rejque(message) {
      this.form.code = message;
      rejectOrderDetail(this.form).then(response => {
        this.form.authorizeCause = ''
        this.$emit("event1",true)
      });
    },
    rejxiao() {
      this.form.authorizeCause = ''
      this.$emit("event1",false)
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
